import { useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useSetRecoilState } from "recoil";
import { useAuth } from "./components/AuthProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import { userData } from "./recoil/atom/userData";
import { privateRoutes } from "./routes/privateRoutes";
import { publicRoutes } from "./routes/publicRoutes";
import { getUserService } from "./service/userService";

function App() {
  const { isAuthenticated, logout } = useAuth();
  const setUserDataDetails = useSetRecoilState(userData);
  const navigate = useNavigate();
  const location = useLocation();
  const fetchUserDetails = async () => {
    try {
      const response = await getUserService()
      setUserDataDetails(response.data);
    } catch {
      logout(navigate("/"));
    }
  };

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/dashboard")) {
      fetchUserDetails();
    }
  }, [location]);

  return (
    <>
      <Routes>
        {
          publicRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={route.component}
            />
          ))
        }
        {
          privateRoutes.map((route, index) => (
            <Route
              key={index}
              path={`/dashboard/${route.path}`}
              element={
                <ProtectedRoute>
                  {route.component}
                </ProtectedRoute>
              }
            />
          ))
        }


        <Route
          path="*"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard/sales" />
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      // transition={Bounce}
      />
    </>
  );
}

export default App;
